import type { Configuration } from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_AZURE_AD_TENANT_ID || "";
const clientId = import.meta.env.VITE_AZURE_AD_CLIENT_ID || "";
const apiScope = import.meta.env.VITE_AZURE_AD_API_SCOPE || (clientId ? `api://${clientId}/access_as_user` : "");

export const isAuthConfigured = Boolean(tenantId && clientId);

export const loginRequest = {
  scopes: apiScope ? [apiScope] : ["openid", "profile"]
};

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: tenantId ? `https://login.microsoftonline.com/${tenantId}` : undefined,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage"
  }
};
